<template>
    <b-overlay :show="loading" class="p-1" opacity="1">
        <div class="row">
            <div class="col-12 mb-1">
                <label class="form-label">Çalışma Süresi</label>
                <v-validator :errors="errors" parameter="DrivingTime" :watch="value.DrivingTime">
                    <v-date-picker v-model="value.DrivingTime" type="time" with-seconds placeholder="Çalışma Süresi"></v-date-picker>
                </v-validator>
            </div>
            <div class="col-12 mb-1">
                <label class="form-label">Gece Çalışma Süresi</label>
                <v-validator :errors="errors" parameter="NightWorkingTime" :watch="value.NightWorkingTime">
                    <v-date-picker v-model="value.NightWorkingTime" type="time" with-seconds placeholder="Gece Çalışma Süresi"></v-date-picker>
                </v-validator>
            </div>
            <div class="col-12 mb-1">
                <label class="form-label">Bilinmeyen Süre</label>
                <v-validator :errors="errors" parameter="UnknownTime" :watch="value.UnknownTime">
                    <v-date-picker v-model="value.UnknownTime" type="time" with-seconds placeholder="Bilinmeyen Süre"></v-date-picker>
                </v-validator>
            </div>
            <div class="col-12">
                <label class="form-label">Kilometre</label>
                <v-validator :errors="errors" parameter="Distance" :watch="value.Distance">
                    <input class="form-control" type="number" v-model="value.Distance" placeholder="Kilometre"/>
                </v-validator>
            </div>
        </div>
    </b-overlay>
</template>

<script>
import EmployeeOperationsApi from '@/api/employee-operations'
import { BOverlay } from 'bootstrap-vue'

export default {
    components:{
        BOverlay
    },
    props:{
        value:Object,
        errors:Object
    },
    data(){
        return {
            loading:true
        }
    },
    mounted(){
        this.getData()
    },
    methods:{
        getData(){
            if(this.value?.Id){
                EmployeeOperationsApi.Tachograph.GetManualTachograph(this.value.Id)
                .then(res=>{
                    this.loading = false
                    if(res.data.Success){
                        this.value.DrivingTime = res.data.Data.DrivingTime
                        this.value.NightWorkingTime = res.data.Data.NightWorkingTime
                        this.value.UnknownTime = res.data.Data.UnknownTime
                        this.value.Distance = res.data.Data.Distance
                    }else{
                        this.$result(res)
                    }
                }).catch(err=>{
                    this.$result(null,err)
                })
            }else{
                this.loading = false
            }
        }
    }
}
</script>

<style>

</style>